// extracted by mini-css-extract-plugin
export default {"address":"AddressLink_address__RsnH0"};